import type { ScopeTierConsolidationProvenance } from '@/shared/hooks/api/radarScopeTier'

export function formatEmbeddingReleaseStatusLabel(
  input: {
    embeddingReleaseStatus: ScopeTierConsolidationProvenance['embeddingReleaseStatus']
    reviewStatus: 'pending' | 'approved' | 'flagged' | 'trashed'
  }
): string | null {
  if (input.reviewStatus !== 'approved') {
    return null
  }
  if (input.embeddingReleaseStatus === 'pending') {
    return 'Embedding in progress'
  }
  if (input.embeddingReleaseStatus === 'failed') {
    return 'Embedding failed'
  }
  return null
}

export function shouldShowRetryMaterializationButton(input: {
  embeddingReleaseStatus: ScopeTierConsolidationProvenance['embeddingReleaseStatus']
  reviewStatus: 'pending' | 'approved' | 'flagged' | 'trashed'
}): boolean {
  if (input.reviewStatus !== 'approved') {
    return false
  }
  return input.embeddingReleaseStatus === 'failed' || input.embeddingReleaseStatus === 'pending'
}
